/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { EvidencePart } from "@interfaces/Interfaces";
import { IonItem, IonLabel, IonList, IonSelect, IonSelectOption } from "@ionic/react";
import { Text, View } from "@react-pdf/renderer";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";
import { updatePopoverTriggerWidth } from "@utils/popoverUtils";

type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  definition: EvidencePart;
  onValueChanged?: (value: any) => void;
  data?: any;
  isDisplay?: boolean;
  isPDF?: boolean;
  pdfStyles: any;
  initialValue?: any;
};

const DropDownList: React.FC<Props> = ({
  definition,
  onValueChanged,
  data,
  isDisplay,
  isPDF,
  pdfStyles,
  initialValue,
}) => {
  const [value, setValue] = useState<string>(initialValue || "");
  const [listValues, setListValues] = useState<string[]>([]);

  useEffect(() => {
    const getListValues = (): void => {
      const values = definition?.["List of values"];

      if (values && values.length > 0) {
        let strings = values.split("\n");
        strings = strings.filter((item) => item.length > 0);

        setListValues(strings);
      }
    };

    definition && getListValues();
  }, [definition]);

  const valueChanged = (item: any) => {
    const _value = item.detail.value;

    setValue(_value);
    onValueChanged && onValueChanged(_value);
  };

  if (isPDF) {
    return (
      <View>
        <Text style={pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(definition)}</Text>
        <Text style={pdfStyles.evidenceDate}>{data}</Text>
      </View>
    );
  }

  if (isDisplay) {
    return (
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">{definition["Display Title"] || definition.Name}</div>
        <div className="readEvidenceText">{data}</div>
        <div className="h-[1px] w-full bg-grey-30 mt-4" />
      </div>
    );
  }

  return (
    <div className="reflectionActivityTypeContainer">
      <IonList
        mode="md"
        className="reflectionActivityList w-full"
        color="white"
      >
        <IonItem
          mode="md"
          className="reflectionActivityItem"
          color="white"
        >
          <IonSelect
            color="white"
            mode="md"
            className="reflectionActivitySelectItem w-full"
            interface="popover"
            justify="space-between"
            interfaceOptions={{
              size: "cover",
              alignment: "start",
              cssClass: "evidence-select-popover",
            }}
            placeholder={definition["Placeholder Text"] || "Select value"}
            value={value || undefined}
            onIonChange={valueChanged}
            onClick={updatePopoverTriggerWidth}
          >
            {listValues.map((item: string) => {
              return (
                <IonSelectOption
                  color="white"
                  key={item}
                  value={item}
                >
                  <IonLabel>{item}</IonLabel>
                </IonSelectOption>
              );
            })}
          </IonSelect>
        </IonItem>
      </IonList>
    </div>
  );
};

export default DropDownList;
